import { FCC } from "@dgs/core";

interface Props {
	label: string;
}

export const LabeledValue: FCC<Props> = ({ label, children }) => {
	return (
		<div>
			<div>{label}:</div>
			<strong>{children}</strong>
		</div>
	);
};
